import * as Yup from 'yup';

const schema = Yup.object()
  .shape({
    phone: Yup.string()
      .required('Campo obrigatório')
      .typeError('Por favor, insira um número de telefone válido')
      .min(11, 'O celular deve ter pelo menos 11 dígitos, incluindo o DDD')
      .transform((value: string) => (value ? value.replace(/\D/g, '') : value)),
    cellPhone: Yup.string()
      .required('Campo obrigatório')
      .typeError('Por favor, insira um número de telefone válido')
      .min(11, 'O celular deve ter pelo menos 14 dígitos, incluindo o DDD')
      .transform((value: string) => (value ? value.replace(/\D/g, '') : value)),
    email: Yup.string()
      .email('E-mail inválido')
      .required('Campo obrigatório')
      .typeError('Por favor, insira um endereço de e-mail válido'),
    zipCode: Yup.string()
      .required('Campo obrigatório')
      .typeError('Por favor, insira um CEP válido')
      .transform((value: string) => (value ? value.replace(/\D/g, '') : value)),
    streetNumber: Yup.string()
      .required('Campo obrigatório')
      .transform((value: string) => (value ? value.replace(/\D/g, '') : value)),
    streetAddress: Yup.string().required('Campo obrigatório'),
    complement: Yup.string().required('Campo obrigatório'),
    neighborhood: Yup.string().required('Campo obrigatório'),
    city: Yup.string().required('Campo obrigatório'),
    state: Yup.string().required('Campo obrigatório'),
  })
  .required();

export type formSchemaType = Yup.InferType<typeof schema>;

export default schema;
